import { render, staticRenderFns } from "./info_chatbot.vue?vue&type=template&id=b87c2b1c&scoped=true"
import script from "./info_chatbot.vue?vue&type=script&lang=js"
export * from "./info_chatbot.vue?vue&type=script&lang=js"
import style0 from "./info_chatbot.vue?vue&type=style&index=0&id=b87c2b1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87c2b1c",
  null
  
)

export default component.exports